export const GET_GEOFENCE = 'V3_GET_GEOFENCE';
export const GET_GEOFENCES = 'V3_GET_GEOFENCES';
export const CU_GEOFENCE = 'V3_CU_GEOFENCE'

export const SET_SELECTED_GEOFENCE_GEOID = "V3_SET_SELECTED_GEOFENCE_GEOID";
export const CLEAR_SELECTED_GEOFENCE_GEOID = "V3_CLEAR_SELECTED_GEOFENCE_GEOID";